function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { children } from '@signal/prop-types';
import componentPropType from '@signal/prop-types/component';
import Popper from '@material-ui/core/Popper';
import Fade from '@material-ui/core/Fade';
import { Wrapper, Target, Content } from './styles';

var Tooltip = /*#__PURE__*/function (_PureComponent) {
  _inherits(Tooltip, _PureComponent);

  var _super = _createSuper(Tooltip);

  function Tooltip() {
    var _this;

    _classCallCheck(this, Tooltip);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      open: false,
      anchorEl: null
    });

    _defineProperty(_assertThisInitialized(_this), "showTooltip", function (evt) {
      var currentTarget = evt.currentTarget;

      _this.setState(function (state) {
        return {
          anchorEl: currentTarget,
          open: true
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "hideTooltip", function (evt) {
      _this.setState(function (state) {
        return {
          anchorEl: null,
          open: false
        };
      });
    });

    return _this;
  }

  _createClass(Tooltip, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          target = _this$props.target,
          style = _this$props.style,
          className = _this$props.className,
          size = _this$props.size,
          bgColor = _this$props.bgColor,
          Wrapper = _this$props.wrapper,
          TargetComponent = _this$props.TargetComponent;
      var _this$state = this.state,
          anchorEl = _this$state.anchorEl,
          open = _this$state.open;
      var id = open ? 'simple-popper' : null;
      return /*#__PURE__*/React.createElement(Wrapper, {
        onMouseEnter: this.showTooltip,
        onMouseLeave: this.hideTooltip
      }, /*#__PURE__*/React.createElement(TargetComponent, null, target), /*#__PURE__*/React.createElement(Popper, {
        id: id,
        open: open,
        anchorEl: anchorEl,
        transition: true
      }, function (_ref) {
        var TransitionProps = _ref.TransitionProps;
        return /*#__PURE__*/React.createElement(Fade, Object.assign({}, TransitionProps, {
          timeout: {
            enter: 350,
            exit: 500
          }
        }), /*#__PURE__*/React.createElement(Content, {
          style: style,
          className: className,
          size: size,
          bgColor: bgColor
        }, children));
      }));
    }
  }]);

  return Tooltip;
}(PureComponent);

_defineProperty(Tooltip, "propTypes", {
  children: children.isRequired,
  target: PropTypes.oneOfType([PropTypes.string, componentPropType]).isRequired,
  size: PropTypes.string,
  bgColor: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string,
  wrapper: componentPropType,
  TargetComponent: componentPropType
});

_defineProperty(Tooltip, "defaultProps", {
  size: 'large',
  bgColor: 'black',
  wrapper: Wrapper,
  TargetComponent: Target
});

export default Tooltip;